// Tab index constants for accessibility
export const INTERACTIVE_TAB_INDEX = 0;
export const NON_INTERACTIVE_TAB_INDEX = -1;

// Badge color variants configuration
export const BADGE_COLOR_CLASSES = {
  blue: "bg-blue-100 text-blue-700 border-blue-300 ",
  green: "bg-green-100 text-green-700 border-green-300",
  red: "bg-red-100 text-red-700 border-red-300",
  yellow: "bg-yellow-100 text-yellow-700 border-yellow-300",
  gray: "bg-gray-100 text-gray-700 border-gray-300",
  primary: "bg-primary-50 text-primary-500 border-primary-300 dark:text-white dark:bg-primary-800 dark:border-primary-500",
};
